import clsx from "clsx";

export function ProgressBar({
  steps,
  current,
}: {
  steps: { key: string; label: string }[];
  current: number;
}) {
  return (
    <div className="w-full">
      <div className="flex items-center gap-2 overflow-x-auto pb-2">
        {steps.map((s, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <div key={s.key} className="flex items-center gap-2 shrink-0">
              <div
                className={clsx(
                  "flex items-center gap-2 rounded-full px-3 py-1.5 text-[12px] font-semibold transition",
                  active && "bg-brand-navy text-white",
                  done && "bg-brand-teal text-white",
                  !active && !done && "bg-white border border-brand-line text-brand-mute",
                )}
              >
                <span
                  className={clsx(
                    "inline-flex h-5 w-5 items-center justify-center rounded-full text-[11px]",
                    active && "bg-white text-brand-navy",
                    done && "bg-white text-brand-teal",
                    !active && !done && "bg-brand-line text-brand-mute",
                  )}
                >
                  {done ? "✓" : i + 1}
                </span>
                {s.label}
              </div>
              {i < steps.length - 1 && (
                <div
                  className={clsx(
                    "h-0.5 w-6 rounded",
                    i < current ? "bg-brand-teal" : "bg-brand-line",
                  )}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
